package pt.at.oss.kotlin.manual.storage.common.bankaccountinfo

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * BankAccountInfo Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class BankAccountInfo(
    var iban: String = "",
    var oban: String = "",
    var bic: String = "",
    var accountHolder: String = ""
) : BaseRecord()
